// Bont Size Charts JavaScript (All 3 Charts In One File)
// Automatically loads correct calculator based on page URL

// --- Page Router ---
document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.pathname;

  if (url.includes("bont-size-chart-slipstream-and-vaypor-boots")) {
    initSlipstreamVaypor();
  } else if (url.includes("bont-size-chart-eclipse-boot")) {
    initEclipse();
  } else if (url.includes("bont-size-chart-parkstar-prostar")) {
    initParkstarProstar();
  } else if (url.includes("bont-size-chart-all-other-inline-and-roller-skate-boots")) {
    initGeneralInlineRoller();
  }
});

// --- Shared Handlers ---
function setupHandlers(runFn) {
  document.querySelector(".goButton a")?.addEventListener("click", function (e) {
    e.preventDefault();
    runFn();
  });

  document.querySelectorAll(".form-text").forEach(input => {
    input.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        runFn();
      }
    });
  });

  document.querySelectorAll(".bont-size-chart-table td").forEach(cell => {
    cell.addEventListener("mouseenter", () => {
      const table = cell.closest("table");
      const index = cell.cellIndex;

      table.querySelectorAll("td, th").forEach(el => el.classList.remove("highlight-col", "highlight-row"));
      table.querySelectorAll("tr").forEach(row => {
        if (row.cells.length > index) row.cells[index].classList.add("highlight-col");
      });
      cell.parentElement.querySelectorAll("td").forEach(td => td.classList.add("highlight-row"));
    });

    cell.addEventListener("mouseleave", () => {
      const table = cell.closest("table");
      table.querySelectorAll("td, th").forEach(el => el.classList.remove("highlight-col", "highlight-row"));
    });
  });
}

// --- Chart 1: Slipstream & Vaypor ---
function initSlipstreamVaypor() {
  setupHandlers(runSlipstreamVaypor);
}

function runSlipstreamVaypor() {
  const left = getBasicSize(+document.getElementById("left-foot-length")?.value);
  const right = getBasicSize(+document.getElementById("right-foot-length")?.value);
  document.querySelector(".left-bont").innerText = `${left.size}`;
  document.querySelector(".right-bont").innerText = `${right.size}`;
}

function getBasicSize(length) {
  const chart = [
    { min: 176, max: 180, size: "180" }, { min: 181, max: 185, size: "185" },
    { min: 186, max: 190, size: "190" }, { min: 191, max: 195, size: "195" },
    { min: 196, max: 200, size: "200" }, { min: 201, max: 205, size: "205" },
    { min: 206, max: 210, size: "210" }, { min: 211, max: 215, size: "215" },
    { min: 216, max: 220, size: "220" }, { min: 221, max: 225, size: "225" },
    { min: 226, max: 230, size: "230" }, { min: 231, max: 235, size: "235" },
    { min: 236, max: 240, size: "240" }, { min: 241, max: 245, size: "245" },
    { min: 246, max: 250, size: "250" }, { min: 251, max: 255, size: "255" },
    { min: 256, max: 260, size: "260" }, { min: 261, max: 265, size: "265" },
    { min: 266, max: 270, size: "270" }, { min: 271, max: 275, size: "275" },
    { min: 276, max: 280, size: "280" }, { min: 281, max: 285, size: "285" },
    { min: 286, max: 290, size: "290" }, { min: 291, max: 295, size: "295" },
    { min: 296, max: 300, size: "300" }, { min: 301, max: 305, size: "305" },
    { min: 306, max: 310, size: "310" }, { min: 311, max: 315, size: "315" }
  ];
  return chart.find(r => length >= r.min && length <= r.max) || { size: "N/A" };
}

// --- Chart 2: Eclipse (same chart) ---
function initEclipse() {
  setupHandlers(runSlipstreamVaypor);
}

// --- Chart 3: Parkstar / Prostar ---
function initParkstarProstar() {
  setupHandlers(runParkstarProstar);
}

function runParkstarProstar() {
  const left = getParkstarSize(+document.getElementById("left-foot-length")?.value);
  const right = getParkstarSize(+document.getElementById("right-foot-length")?.value);
  document.querySelector(".left-bont").innerText = `Bont: ${left.size}`;
  document.querySelector(".left-euro").innerText = `EU: ${left.euro}`;
  document.querySelector(".right-bont").innerText = `Bont: ${right.size}`;
  document.querySelector(".right-euro").innerText = `EU: ${right.euro}`;
}

function getParkstarSize(length) {
  const chart = [
    { min: 174, max: 182, size: "10 C", euro: "28" },
    { min: 183, max: 190, size: "11 C", euro: "29" },
    { min: 191, max: 198, size: "12 C", euro: "30" },
    { min: 199, max: 202, size: "13 C", euro: "31" },
    { min: 203, max: 206, size: "13.5 C", euro: "32" },
    { min: 207, max: 218, size: "1", euro: "33" },
    { min: 219, max: 223, size: "2", euro: "34" },
    { min: 219, max: 223, size: "2.5", euro: "34.5" },
    { min: 224, max: 228, size: "3", euro: "35" },
    { min: 229, max: 231, size: "3.5", euro: "35.5" },
    { min: 232, max: 237, size: "4", euro: "36" },
    { min: 238, max: 241, size: "4.5", euro: "36.5" },
    { min: 242, max: 245, size: "5", euro: "37" },
    { min: 246, max: 250, size: "5.5", euro: "37.5" },
    { min: 251, max: 253, size: "6", euro: "38" },
    { min: 254, max: 259, size: "6.5", euro: "38.5" },
    { min: 260, max: 262, size: "7", euro: "39" },
    { min: 263, max: 268, size: "7.5", euro: "40" },
    { min: 269, max: 272, size: "8", euro: "41" },
    { min: 273, max: 277, size: "8.5", euro: "41.5" },
    { min: 278, max: 281, size: "9", euro: "42" },
    { min: 282, max: 286, size: "9.5", euro: "43" },
    { min: 287, max: 290, size: "10", euro: "44" },
    { min: 291, max: 295, size: "10.5", euro: "45" },
    { min: 296, max: 298, size: "11", euro: "46" },
    { min: 299, max: 302, size: "11.5", euro: "47" },
    { min: 303, max: 304, size: "12", euro: "48" },
    { min: 305, max: 311, size: "12.5", euro: "49" },
    { min: 312, max: 313, size: "13", euro: "50" }
  ];
  return chart.find(r => length >= r.min && length <= r.max) || { size: "N/A", euro: "N/A" };
}

// --- Chart 4: All Other Inline & Roller Boots ---
function initGeneralInlineRoller() {
  setupHandlers(runGeneralInlineRoller);
}

function runGeneralInlineRoller() {
  const left = getGeneralSize(+document.getElementById("left-foot-length")?.value);
  const right = getGeneralSize(+document.getElementById("right-foot-length")?.value);
  document.querySelector(".left-bont").innerText = `Bont: ${left.size}`;
  document.querySelector(".left-euro").innerText = `EU: ${left.euro}`;
  document.querySelector(".right-bont").innerText = `Bont: ${right.size}`;
  document.querySelector(".right-euro").innerText = `EU: ${right.euro}`;
}

function getGeneralSize(length) {
  const chart = [
    { min: 150, max: 162, size: "9 C", euro: "27", width: "Narrow" },
    { min: 163, max: 171, size: "10 C", euro: "28", width: "Narrow" },
    { min: 172, max: 179, size: "11 C", euro: "29", width: "Standard" },
    { min: 180, max: 188, size: "12 C", euro: "30", width: "Standard" },
    { min: 189, max: 198, size: "13 C", euro: "31", width: "Standard" },
    { min: 199, max: 203, size: "13.5 C", euro: "32", width: "Standard" },
    { min: 204, max: 207, size: "1", euro: "33", width: "Wide" },
    { min: 208, max: 215, size: "2", euro: "34", width: "Wide" },
    { min: 216, max: 219, size: "2.5", euro: "34.5", width: "Wide" },
    { min: 220, max: 224, size: "3", euro: "35", width: "Wide" },
    { min: 225, max: 228, size: "3.5", euro: "35.5", width: "Wide" },
    { min: 229, max: 232, size: "4", euro: "36", width: "Wide" },
    { min: 233, max: 237, size: "4.5", euro: "36.5", width: "Wide" },
    { min: 238, max: 241, size: "5", euro: "37", width: "Wide" },
    { min: 242, max: 246, size: "5.5", euro: "37.5", width: "Wide" },
    { min: 247, max: 250, size: "6", euro: "38", width: "Wide" },
    { min: 251, max: 255, size: "6.5", euro: "38.5", width: "Wide" },
    { min: 256, max: 259, size: "7", euro: "39", width: "Wide" },
    { min: 260, max: 264, size: "7.5", euro: "40", width: "Wide" },
    { min: 265, max: 268, size: "8", euro: "41", width: "Wide" },
    { min: 269, max: 272, size: "8.5", euro: "41.5", width: "Wide" },
    { min: 273, max: 277, size: "9", euro: "42", width: "Wide" },
    { min: 278, max: 281, size: "9.5", euro: "43", width: "Wide" },
    { min: 282, max: 286, size: "10", euro: "44", width: "Wide" },
    { min: 287, max: 290, size: "10.5", euro: "45", width: "Wide" },
    { min: 291, max: 295, size: "11", euro: "46", width: "Wide" },
    { min: 296, max: 299, size: "11.5", euro: "47", width: "Wide" },
    { min: 300, max: 304, size: "12", euro: "48", width: "Wide" },
    { min: 305, max: 308, size: "12.5", euro: "49", width: "Wide" },
    { min: 309, max: 313, size: "13", euro: "50", width: "Wide" },
    { min: 314, max: 317, size: "13.5", euro: "51", width: "Wide" }
  ];
  return chart.find(r => length >= r.min && length <= r.max) || { size: "N/A", euro: "N/A", width: "N/A" };
}
